export default "<!-- <p>sample works!</p> -->\n\n<pre class=\"p-5\">\n\n\n\n\n\n\n\n</pre>";